export const NAME = 'tasksOverview';

export const TASK = 0;

export const INFORMATION = 1;

export const QUICK_FILTER_STATES = {
	all: 'all',
	tasks: 'tasks',
	info: 'info',
	processed: 'processed',
};

export const TASK_STATUS = {
	inTime: 1,
	nearEnd: 2,
	past: 3,
};

// FE to BE
export const relations = {
	policyNumber: 'policyNo',
	taskType: 'taskTypeId',
	finishTypeId: 'finishTypeId',
	id: 'id',
	taskSubTypeId: 'taskSubtypeId',
	productDomain: 'productDomainId',
	firstName: 'clientFirstname',
	surname: 'clientSurname',
	businessName: 'businessName',
	deadlineFrom: 'deadlineFrom',
	deadlineTo: 'deadlineTo',
};

export const TARIF_DEFAULT = 'Neexistující tarif';

export const formDataFieldsMap = {
	policyNo: 'Číslo PS',
	taskTypeId: 'Typ úkolu',
	finishTypeId: 'Splnění úkolu',
	productArea: 'Produktová oblast',
	taskSubType: 'Podtyp / Důvod kontaktování',
	id: 'ID úkolu',
	surname: 'Příjmení klienta',
	firstName: 'Jméno klienta',
	businessName: 'Název klienta',
	deadlineFrom: 'Termín splnění od',
	deadlineTo: 'Termín splnění do',
	quickFilterAll: 'Všechny',
	quickFilterTasks: 'Úkoly',
	quickFilterInfo: 'Informace',
	quickFilterProcessed: 'Zpracované',
};

export const quickFilterTypesSetup = [
	{
		label: 'tasksOverview:all',
		type: QUICK_FILTER_STATES.all,
	},
	{
		label: 'tasksOverview:tasks',
		type: QUICK_FILTER_STATES.tasks,
	},
	{
		label: 'tasksOverview:info',
		type: QUICK_FILTER_STATES.info,
	},
	{
		label: 'tasksOverview:processed',
		type: QUICK_FILTER_STATES.processed,
	},
];
